









































import Vue from 'vue';
import Component from 'vue-class-component';

import ReviewToolbarLink from './ReviewToolbarLink.vue';
import ReviewStats from './ReviewStats.vue';
import { Getter, Action } from 'vuex-class';

@Component({ components: { ReviewToolbarLink, ReviewStats } })
export default class ReviewToolbar extends Vue {

  @Action('processModule/setReviewProcess') setReviewProcess!: Function;

  deleteReviewProcess() {
    this.setReviewProcess(null);
  }
  openReviewStatisticsModal() {
    const modal: any = this.$refs.reviewStatisticsModal;
    modal.open();
  }
  openUploadReviewToCreatorModal() {
    const modal: any = this.$refs.uploadReviewToCreatorModal;
    modal.open();
  }
  openDeleteReviewModal() {
    const modal: any = this.$refs.deleteReviewModal;
    modal.open();
  }
}
